export function setFolderHandling(children, canHandleFolders) {
    if (!Array.isArray(children)) return

    for (const child of children) {
        if (child.type !== "group") {
            child.isAlias = true
            continue
        }

        setDynamicFolderHandling(child, canHandleFolders)
        setFolderHandling(child.children, canHandleFolders)
    }
}

export function setDynamicFolderHandling(child, canHandleFolders) {
    Object.defineProperty(child, "folderHandling", {
        configurable: true,
        enumerable: true,
        get: canHandleFolders,
    })
}
